import { MutationTree } from 'vuex';
import { MyDeviceState } from './MyDeviceTypes';
import { DocumentReference } from '@firebase/firestore-types';

export const mutations: MutationTree<MyDeviceState> = {
  setCurrentStoreDeviceRef: (state: MyDeviceState, payload: DocumentReference) => {
    state.currentStoreDeviceRef = payload;
  },
};
